module.exports = __webpack_public_path__ + "static/skippedheading-8c194b77460f199755b3655d981b1653.png";